#### `PostedPositionProfile.seekCreatedBySelfIndicator` field

The SEEK API provides access to the job ads and candidate applications of your hirers.
This may include job ads posted directly by a hirer on the SEEK Employer website.

While we recommend handling job ads and candidate applications posted outside of your software,
we understand that this isn’t always possible depending on the design of your software.
The new [`PostedPositionProfile.seekCreatedBySelfIndicator`] field allows you to identify whether your software posted a given job ad.

See the updated [Job ads posted outside of your software] documentation for guidance on using this field.

[`postedpositionprofile.seekcreatedbyselfindicator`]: /schema/named-type/PostedPositionProfile#/field/seekCreatedBySelfIndicator
[job ads posted outside of your software]: /use-cases/application-export#job-ads-posted-outside-of-your-software
